import React from 'react';
import { Link } from 'react-router-dom';

const LandingFooter = () => (
  <footer className="landing-footer">
    <div className="footer-inner">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Manzili Smart" style={{ height: 80, maxWidth: '100%' }} />
          </div>
          <p className="footer-desc">
            Smart home automation platform powered by Siemens Desigo Optic.
            Professional-grade building intelligence for residents and managers.
          </p>
        </div>

        <div className="footer-col">
          <h6>Platform</h6>
          <ul>
            <li><a href="#features">Features</a></li>
            <li><a href="#siemens">Technology</a></li>
            <li><a href="#how-it-works">How It Works</a></li>
            <li><a href="#about">About</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h6>Legal</h6>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Use</Link></li>
            <li><Link to="/support">Support</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h6>Contact</h6>
          <ul>
            <li><span>Doha, Qatar</span></li>
            <li><span>+974 6000 2681</span></li>
            <li><a href="https://epo-power.com/" target="_blank" rel="noopener noreferrer">epo-power.com</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-copy">
          © {new Date().getFullYear()} EPO Power and Control Trading. All rights reserved.
        </span>
        <span className="footer-powered">
          Powered by <span>Siemens Desigo Optic</span>
        </span>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
